import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import BForm from 'JS/components/blain-form/BForm.vue';
import bugsnagClient from 'JS/global/bugsnag';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import UiButton from 'JS/components/UiButton.vue';
import { BSubmitButton } from 'JS/components/blain-form';
import { BTextField } from 'JS/components/blain-form';
import { IRecoveryResponse } from 'JS/types/Account';
import { nextTick, onMounted, ref } from 'vue';
import { useServices } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordPage',
  props: {
    isFullScreenVersion: { type: Boolean },
    email: null,
    antiForgeryToken: null
  },
  emits: ["loading", "go-back"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'loading', value: boolean): void
	(e: 'go-back'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	isFullScreenVersion: boolean,
	email: string,
	antiForgeryToken: string,
}





const { accountService } = useServices();

const headerElement = ref<HTMLElement | null>(null);

const email = ref<string>();
const result = ref<IRecoveryResponse>();
const error = ref<string>();
const unreceivedEmail = ref(false);

function handleUnreceivedEmail() {
	unreceivedEmail.value = true;
	nextTick(() => headerElement.value?.focus());
}

async function recoverPassword() {
	unreceivedEmail.value = false;
	error.value = undefined;

	emit('loading', true);
	try {

		// For security reasons, we will not indicate the success of the result.
		result.value = await accountService.recoverPassword(email.value, props.antiForgeryToken);
	} catch (e) {
		error.value = "<span class='bold'>Something went wrong.</span> Please try again later.";
		bugsnagClient.notify(e, {
			metaData: {
				info: "Failed to send password recovery email"
			}
		});
	} finally {
		emit('loading', false);
		headerElement.value?.focus();
	}
}

onMounted(() => {
	email.value = props.email;
	headerElement.value?.focus();
});


return { __sfc: true,props, emit, accountService, headerElement, email, result, error, unreceivedEmail, handleUnreceivedEmail, recoverPassword, validation, BForm, ErrorBanner, LinkButton, UiButton, BSubmitButton, BTextField }
}

})